import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';
import ReactMarkdown from 'react-markdown';

export function Privacy() {
  const [privacy, setPrivacy] = useState('Loading...');

  useEffect(() => {
    fetchPrivacy();
  }, []);

  const fetchPrivacy = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('privacy_policy')
        .eq('id', 1)
        .single();

      if (error) throw error;
      setPrivacy(data.privacy_policy);
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setPrivacy('Failed to load Privacy Policy');
    }
  };

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-card rounded-lg shadow-sm p-8 border">
          <article className="prose dark:prose-invert max-w-none">
            <ReactMarkdown>{privacy}</ReactMarkdown>
          </article>
        </div>
      </div>
    </div>
  );
}